// GENERATED BY ./src/scripts/generateComponents.ts
// DO NOT EDIT IT MANUALLY

import React from "react";

import { iconSolvbtc } from "../../../icons/mono/build/icon-solvbtc.icon";
import { IconComponentBaseProps } from "../../../utils";
import { Image } from "../../Base/Image";

const SolvbtcIcon = (props: IconComponentBaseProps) => {
  return <Image svgCode={iconSolvbtc.data} {...props} />;
};

if (process.env.NODE_ENV !== 'production') {
  SolvbtcIcon.displayName = 'SolvbtcIcon';
}

export default SolvbtcIcon;